import {
    ICategoricalGroup2GoodsUnionDTO,
    ICategoricalGroup2GoodsUnionViewDTO,
    ICategoricalGroupLinkUnionDTO,
    ICategoricalGroupLinkUnionViewDTO,
    ICategoricalGroupUnionDTO,
    ICategoricalGroupUnionViewDTO
} from "../../libs/coreapi-dto/dirs/categoricalGroup";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class CategoricalGroupUnionDataProvider extends DictionaryDataProvider<ICategoricalGroupUnionViewDTO, ICategoricalGroupUnionDTO> {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ICategoricalGroupUnionViewDTO, ICategoricalGroupUnionDTO>> {
        return this._coreApiService.categoricalGroupUnionRequest;
    }

    viewParam(body: IViewBody, callback: (data: ICategoricalGroupUnionViewDTO[], totalCount: number) => void, signal?: AbortSignal | null) {
        this._coreApiService.categoricalGroupUnionRequest
            .then(r => r
                .getViewParam(body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'CategoricalGroupUnionDataProvider getView !isCompleted');
                }, signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getView CategoricalGroupUnionDataProvider')
            });
    }
}

export class CategoricalGroup2GoodsUnionDataProvider extends DictionaryDataProvider<ICategoricalGroup2GoodsUnionViewDTO, ICategoricalGroup2GoodsUnionDTO> {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ICategoricalGroup2GoodsUnionViewDTO, ICategoricalGroup2GoodsUnionDTO>> {
        return this._coreApiService.categoricalGroup2GoodsUnionRequest;
    }

    viewParam(body: IViewBody, callback: (data: ICategoricalGroup2GoodsUnionViewDTO[], totalCount: number) => void, signal?: AbortSignal | null) {
        this._coreApiService.categoricalGroup2GoodsUnionRequest
            .then(r => r
                .getViewParam(body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'CategoricalGroup2GoodsUnionDataProvider getView !isCompleted');
                }, signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getView CategoricalGroup2GoodsUnionDataProvider')
            });
    }
}

export class CategoricalGroupLinkUnionDataProvider extends DictionaryDataProvider<ICategoricalGroupLinkUnionViewDTO, ICategoricalGroupLinkUnionDTO> {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ICategoricalGroupLinkUnionViewDTO, ICategoricalGroupLinkUnionDTO>> {
        return this._coreApiService.categoricalGroupLinkUnionRequest;
    }

    viewParam(body: IViewBody, callback: (data: ICategoricalGroupLinkUnionViewDTO[], totalCount: number) => void, signal?: AbortSignal | null) {
        this._coreApiService.categoricalGroupLinkUnionRequest
            .then(r => r
                .getViewParam(body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'CategoricalGroupLinkUnionDataProvider getView !isCompleted');
                }, signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getView CategoricalGroupLinkUnionDataProvider')
            });
    }
}